<!-- <img src="assets/images/background.png" class="Background"> -->
<div class="parent">
  <!-- control bar in the left [ngClass]="{'col-2 col-md-2':isNavbar,'col-1 col-md-1':!isNavbar}" -->
  <div class="deviceDetails" [ngStyle]="{'margin': deviceCount >= 4 ? '0 0 0 40px' : '0 0 0 80px'}">

    <div class="sidebar-top">
      <div class="cliqtest-logo"></div>
    </div>

    <div class="sidebar-middle">
      <button (click)="key('home')" title="Home" class="navbarbuttons" aria-label="Home">
        <!-- <img class="icons" src="assets/NavButtons/home.png" /> -->
        <!-- <i class="fa fa-home icons" aria-hidden="true"></i> -->
        <i class="fa-solid fa-house icons"></i>
      </button>

      @if (!deviceInControl?.ios) {
      <button (click)="key('app_switch')" title="Recent Apps" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/app.png" /> -->
        <i class="bi bi-distribute-horizontal icons" aria-hidden="true"></i>
      </button>
      }

      <button (click)="press('power')" title="Lock" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/Lock.png" /> -->
        <i class="fa fa-lock icons" aria-hidden="true"></i>
      </button>

      @if (!deviceInControl?.ios) {
      <button (click)="press('menu')" title="Unlock" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/Unlock.png" /> -->
        <i class="fa fa-unlock-alt icons" aria-hidden="true"></i>
      </button>
      }

      <button (click)="openSettings()" title="Settings" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/settings.png" /> -->

        <i class="fa fa-cog icons" aria-hidden="true"></i>
      </button>



      @if (!deviceInControl?.ios) {
      <button (click)="$event.stopPropagation(); toggleThrottleOptions()" title="Throttle Network"
        class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/signal-status.png" /> -->
        <i class="fa fa-signal icons" aria-hidden="true"></i>
      </button>
      }

      @if (showThrottleOptions) {
      <div class="throttle-dropdown-wrapper">
        <div class="throttle-arrow"></div>
        <div class="throttle-dropdown">
          @for (opt of throttleOptions; track opt) {
          <button (click)="applyThrottle(opt)" class="throttle-option-btn">
            {{ opt.label }}
          </button>
          }
        </div>
      </div>
      }

      <button (click)="aboutDeviceToggle()" title="About Device" class="navbarbuttons">
        <!-- <img class="icons" src="assets/NavButtons/info.png" /> -->
        <i class="fa fa-info-circle icons" aria-hidden="true"></i>
      </button>

      <button title="Minimize the full-view" style="margin-top: 20px;" class="navbarbuttons" onclick="history.back()">
        <i class="fa-solid fa-compress icons"></i>
      </button>



    </div>
  </div>
  <div class="spacer-in-between"></div>
  <!-- main device mobileScreen div -->
  <div class="mobileScreen">
    <div class="positioner" [ngClass]="{'selected-shadow': deviceInControl === device}">
      @if (loader) {
      <div [ngStyle]="{'cursor':cursor,'aspect-ratio':canvasAspect}" class="mainDivLoader">
        <span [ngClass]="{'bi bi-android android': device?.platform == 'Android',
                                  'bi bi-apple iOS': device?.platform == 'iOS'}">
        </span>
        <label class="loadbar" [ngStyle]="{'top': getTopPosition(device)}">
          <span class="sr-only"></span>
          <progress class="progressBar"></progress>
        </label>
      </div>
      }
      <img [ngStyle]="{'aspect-ratio':canvasAspect}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png">
      <canvas #canvas class="screen"></canvas>
      <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
        focus-element="$root.screenFocus" />
    </div>
    <div class="device-name">{{device?.model}}</div>
  </div>
  <!-- device1 mobileScreen div -->
  <div class="mobileScreen">
    <div class="positioner" [ngClass]="{'selected-shadow': deviceInControl === device1}">
      @if (loader1) {
      <div [ngStyle]="{'cursor':cursor1,'aspect-ratio':canvasAspect1}" class="mainDivLoader">
        <span [ngClass]="{
                                 'bi bi-android android': device1?.platform == 'Android',
                                 'bi bi-apple iOS': device1?.platform == 'iOS'}">
        </span>
        <label class="loadbar" [ngStyle]="{'top': getTopPosition(device1)}">
          <span class="sr-only"></span>
          <progress class="progressBar"></progress>
        </label>
      </div>
      }
      <img [ngStyle]="{'aspect-ratio':canvasAspect1}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png">
      <canvas #canvas1 class="screen"></canvas>
      <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
        focus-element="$root.screenFocus" />
    </div>
    <div class="device-name">{{device1?.model}}</div>
  </div>
  <!-- device2 mobileScreen div -->
  <div [ngStyle]="{'display':deviceCount>=3?'flex':'none'}" class="mobileScreen">
    <div class="positioner" [ngClass]="{'selected-shadow': deviceInControl === device2}">
      @if (loader2) {
      <div [ngStyle]="{'cursor':cursor2,'aspect-ratio':canvasAspect2}" class="mainDivLoader">
        <span [ngClass]="{
                                 'bi bi-android android': device2?.platform == 'Android',
                                 'bi bi-apple iOS': device2?.platform == 'iOS'}">
        </span>
        <label class="loadbar" [ngStyle]="{'top': getTopPosition(device2)}">
          <span class="sr-only"></span>
          <progress class="progressBar"></progress>
        </label>
      </div>
      }
      <img [ngStyle]="{'aspect-ratio':canvasAspect2}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png">
      <canvas #canvas2 class="screen"></canvas>
      <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
        focus-element="$root.screenFocus" />
    </div>
    <div class="device-name">{{device2?.model}}</div>
  </div>
  <!-- device3 mobileScreen div -->
  <div [ngStyle]="{'display':deviceCount>=4?'flex':'none', }" class="mobileScreen">
    <div class="positioner" [ngClass]="{'selected-shadow': deviceInControl === device3}">
      @if (loader3) {
      <div [ngStyle]="{'cursor':cursor3,'aspect-ratio':canvasAspect3}" class="mainDivLoader">
        <span [ngClass]="{
                                 'bi bi-android android': device3?.platform == 'Android',
                                 'bi bi-apple iOS': device3?.platform == 'iOS'}">
        </span>
        <label class="loadbar" [ngStyle]="{'top': getTopPosition(device3)}">
          <span class="sr-only"></span>
          <progress class="progressBar"></progress>
        </label>
      </div>
      }
      <img [ngStyle]="{'aspect-ratio':canvasAspect3}" class="wrapper" src="assets/Wrapper/Mobile_wrapper.png">
      <canvas #canvas3 class="screen"></canvas>
      <input type="text" tabindex="40" accesskey="C" autocorrect="off" autocapitalize="off"
        focus-element="$root.screenFocus" />
    </div>
    <div class="device-name">{{device3?.model}}</div>
  </div>
  <div class="spacer-in-between"></div>
</div>
@if (aboutDevice) {
<div [ngStyle]="{'top':deviceInControl?.ios?'21.5em':'26em','left':'10em'}" class="aboutDevice">
  <div class="w-full max-w-xs bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg p-6 text-white">
    <div class="flex justify-between items-center mb-4">
      <h3
        [ngClass]="{'bi bi-android':deviceInControl?.platform=='Android','bi bi-apple':deviceInControl?.platform=='iOS'}"
        class="text-xl font-bold"> {{deviceInControl?.model}}</h3>
    </div>
    <div>
      <h6>{{deviceInControl?.platform=='iOS'?'Apple':deviceInControl?.manufacturer}}</h6>
    </div>
    <div class="space-y-3">
      <p class="text-sm opacity-80">S/N: {{deviceInControl?.serial}}</p>
      <div class="progress mb-2" style="height: 7px;">
        <div class="progress" style="background-color: rgb(4 161 4); height: 7px;align-items: center;"
          [ngStyle]="{'width':deviceInControl?.battery?.level+'%'}">
          <span style="position: relative;left: 43%;font-size: 8px;">{{deviceInControl?.battery?.level+'%'}}</span>
        </div>
      </div>
      <span class="ml-2 text-sm">Battery Status: {{deviceInControl?.battery?.status}}</span>
      <div class="flex items-center">
        <div class="w-full bg-white/30 rounded-full h-2.5">
          <div class="bg-green-500 h-2.5 rounded-full"></div>
        </div>
        <span class="ml-2 text-sm">Version: {{deviceInControl?.version}}</span>
      </div>
      <div class="flex items-center">
        <span class="bi bi-reception-4">{{deviceInControl?.network?.type}}</span>
      </div>
      <div class="flex items-center">
        <span></span>
      </div>
    </div>
  </div>
</div>
}
@if (screenRecord) {
<div _ngcontent-ng-c1826359624="">
  <app-draggable-component (screenRecordFunc)="screenRecord"></app-draggable-component>
</div>
}
<ng-template #screenshotAlert let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{msg | translate}}</p>
    <div class="alert-actions">
      <button type="button" class="btn btn-success" (click)="Ok()">OK</button>&nbsp;
    </div>
  </div>
</ng-template>
<ng-template #AppUpload let-modal>
  <div class="modal-body text-center">
    <p class="alert-message" style="overflow-wrap: break-word;">{{"Upload the apk file" | translate}}</p>

    <label id="file-upload" class="drop-area file-input btn-file ng-isolate-scope">
      <input #appInstall type="file" id="file-upload" accept=".apk" (input)="onFileSelected($event)"
        class="ng-isolate-scope" style="display: none;">
      <i class="fa fa-2x fa-upload drop-area-icon" style="cursor: pointer;"></i>
      <div class="drop-area-text"><span style="cursor: pointer;">{{"Drop file to upload" | translate}}</span>
      </div>
    </label>

    @if (appInstalling) {
    <div class="progress">
      <div class="progress-bar" role="progressbar" [style.width.%]="progress" [attr.aria-valuenow]="progress"
        aria-valuemin="0" aria-valuemax="100">
        {{ "Uploading " + progress }}%
      </div>
    </div>
    }
    <button class="btn btn-primary mt-3" (click)="Ok()">Ok</button>
  </div>
</ng-template>